"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useHovered = require("../../../util/useHovered");
var _useFocusElement = require("../hooks/useFocusElement");
var _ToolbarButtonBase = require("./ToolbarButtonBase");
const ToolbarButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    isDisabled = false,
    width,
    maxWidth,
    isTooltipVisualOnly,
    textAlign,
    ...rest
  } = _ref;
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref,
    onFocus: rest.onFocus,
    onKeyDown: rest.onKeyDown,
    onBlur: rest.onBlur
  });
  const {
    isHovered,
    onMouseEnter,
    onMouseLeave
  } = (0, _useHovered.useHovered)({
    onMouseEnter: rest.onMouseEnter,
    onMouseLeave: rest.onMouseLeave
  });
  return /*#__PURE__*/_react.default.createElement(_ToolbarButtonBase.ToolbarButtonBase, (0, _extends2.default)({}, rest, {
    ref: focusProps.ref,
    isDisabled: isDisabled,
    isHovered: isHovered,
    text: children,
    onFocus: focusProps.onFocus,
    onBlur: focusProps.onBlur,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    tabIndex: rest.tabIndex === 0 ? rest.tabIndex : focusProps.tabIndex,
    onKeyDown: focusProps.onKeyDown,
    width: width,
    maxWidth: maxWidth,
    textAlign: textAlign,
    tooltipVisualOnly: isTooltipVisualOnly,
    onClick: e => {
      rest.onClick(e);
    }
  }));
});
exports.ToolbarButton = ToolbarButton;
ToolbarButton.displayName = "ToolbarButton";
//# sourceMappingURL=ToolbarButton.js.map